import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { LoadingState } from "../../helpers/enum";
import AlertTypeCategory from '../AccountAlertTypes/accountAlertTypeCategory';
import BackButton from '../../Shared/BackButton';
import { isMobile } from '../../helpers/utils';
import { Header, LinkButton, LoadingMask } from '../../Shared';
import { MobileInputContainer } from '../../Shared';
import InputWithIcon from '../../Shared/Input/InputWithIcon';
import _ from 'lodash';


class AccountAlertTypePage extends Component {
    constructor(props) {
        super(props);
        this.name = props.match.params.name;
        this.accountno = props.match.params.accountno;                   
        this.nickname = props.match.params.nickname;
        this.alertname = props.match.params.alertname;


        let amount = 0;

        let status = false;

        this.state = {
            amount: amount,
            oldAmount: amount,
            status : status 
        }  
        
    }

    componentWillMount() {
        this.props.getAccountAlertTypes(this.accountno);

    }

    componentDidMount() {
        this.props.getAccountAlertRegistrations(this.accountno);
    
       
        if (this.props.bankingAlertsState !== LoadingState.FULFILLED) {
            this.props.bankingAlerts();
            this.props.accountAlerts();         
        
        }
    }

    componentDidUpdate() {
        setTimeout(() => {
            var root = document.getElementById("root");

            var _event = {};

            _event = {
                name: 'END_SETTING_HEIGHT',
                height: root.parentElement.parentElement.offsetHeight
            };

            //Post END Height Event for OLB 
            window.parent.postMessage(_event, '*')
        },
            0)

        const { accountAlertPreferencesReducer = {} } = this.props;

        const { accountAlertTypes = {} } = this.props;

        if (accountAlertPreferencesReducer.loadingState === LoadingState.FULFILLED && accountAlertTypes.loadingState === LoadingState.FULFILLED && this.state.status === false) {
            const alertTypes = accountAlertTypes.items.filter(at => at.name === this.name);  

            const alertRegistrations = accountAlertPreferencesReducer.items.filter(
                s => s.typeName === this.name);

                 //  alert Criteria Logic                
            this.hasAlertCriteria = !!_.get(alertTypes[0], 'alertCriteria[0].type', null);
            if (this.hasAlertCriteria) {
                let criteriaAmount = _.get(alertRegistrations, '[0].alertCriteria[0].value', '');
                this.setState({
                    amount: criteriaAmount,
                    oldAmount: criteriaAmount,
                    status: true
                })             
            }         
        }

       
    };

    isEnabled = (alertRegistrations, id) => {
        var regs = alertRegistrations.find(reg => {
            return reg.deliveryMethod === id;
        });
        if (regs) {
            return [regs];
        }
        return [];
    }  

    handleChange = (e) => {
        let formattedAmount = 0;
        if (e.target.value === "" || e.target.value === "0" || e.target.value === "0.0") {
            formattedAmount = "";
        }
        else {
            formattedAmount = (Math.round(parseInt(e.target.value.replace('.', ''))) / 100).toFixed(2);
        }
        this.setState({
            amount: formattedAmount
           
        })      
    }


    onBlur = (alertRegistrations) => {       
        if (this.state.amount !== this.state.oldAmount)
        {
            const registrationIds = alertRegistrations.map(item => item.id);
            this.props.updateAlertCriteria([{
                type: "Amount", value: this.state.amount || 0.00
            }], registrationIds);
            if (this.state.amount !== "")
            {
                this.setState({
                    oldAmount: this.state.amount
                }) 
            }
        }
        

    }


    render() {

        const { accountAlertPreferencesReducer = {} } = this.props;
      
        const { accountAlertTypes = {} } = this.props;

        const textItems = this.props.deliveryAddresses.filter(s => s.channel === "SMS" && s.phoneNumber);
        textItems.forEach((item, i) => {

            item.address = item.countryCode +
                '-' + item.areaCode +
                '-' + item.phoneNumber;

            item.displayValue = item.countryCode +
                '-' + item.areaCode +
                '-' + item.phoneNumber.substring(0, 3) +
                '-' + item.phoneNumber.substring(3, 7)
        });

        const emailItems = this.props.deliveryAddresses.filter(
            s => s.channel === "Email"
        );
        const pushItems = this.props.deliveryAddresses.filter(
            s => s.channel === "Push" && s.nickname
        );
        pushItems.forEach((item, i) => {
            item.address = item.nickname;
        })     
      
        if (!accountAlertPreferencesReducer.loadingState || accountAlertPreferencesReducer.loadingState === LoadingState.PENDING) {
            return <LoadingMask ctrlCss="fullpage" NavigationLink={`Account Alerts for ${this.name.substr(-5)}`} />;
        }

        else if (accountAlertPreferencesReducer.loadingState === LoadingState.FULFILLED && accountAlertTypes.loadingState === LoadingState.FULFILLED) {
            const alertRegistrations = accountAlertPreferencesReducer.items.filter(
                s => s.typeName === this.name
            );   

            const categories = [];
            const categoryContent = [];

            const alertTypes = accountAlertTypes.items.filter(at => at.name === this.name);                   
            alertTypes[0].deliveryChannels.forEach(deliveryChannnel => {
                if (deliveryChannnel === "Push") {
                    categories.push("Push Notification");
                    categoryContent.push(pushItems);
                } else if (deliveryChannnel === "SMS") {
                    categories.push("Text Message");
                    categoryContent.push(textItems);
                }
                else if (deliveryChannnel === "Email") {
                    categories.push("Email");
                    categoryContent.push(emailItems);
                }
            })

            let route = "#/accountalerts/" + this.accountno  + '/' + this.alertname  + '/' + this.nickname
                       

            return (
                <div>
                    <div aria-live="polite">
                        {this.props.accountAlertState === LoadingState.PENDING && <LoadingMask ctrlCss="overlay" />}
                    </div>
                    <div className={isMobile() ? `mobilecontainer-box mobile-font-family` : `container-box`} >
                        <BackButton
                            href={route}
                            text="Notification Center"
                        />
                        <Header
                            mainHeading={`${this.name}`}
                            subHeading={(isMobile() ? `${this.name}` : '')}
                            subHeadingDesc={(isMobile() ? `${alertTypes[0].description}` : '')}

                        />
                         {!isMobile() ?
                        <div className="comp-header comp-header-subHeader-desc-prescription italic" role="text">
                            <p id="DescriptionText2">If you do not see your email or phone number listed, please visit {" "}
                                <a aria-label="Add/Edit Delivery Methods" className="AppLink desktop bold underline" href="#/alertPreferences/addOrEditMethodComponent"> Add/Edit Delivery Methods.
                                </a>
                            </p> 
                        </div> : `` }
                        {                          
                            this.hasAlertCriteria ?
                                isMobile() ?
                                    <div className="textbox-alignment">
                                        <MobileInputContainer
                                            inputValue={this.state.amount}
                                            validationMessage={""}
                                            showValidation={!false}
                                            changeHandler={this.handleChange}
                                            needMask={false}
                                            onBlur={this.onBlur(alertRegistrations)}
                                            inputWithSymbol={true}
                                        />
                                    </div>
                                    :
                                    <InputWithIcon value={this.state.amount} placeholder={"Enter Amount"} onChange={this.handleChange}
                                        onBlur={this.onBlur} /> : ''

                        }
                        <div className="align-hr-item" />
                        {                           
                            categories.map((channel, i) => (
                                <AlertTypeCategory
                                    key={i}
                                    header={channel}
                                    items={categoryContent[i]}
                                    alertRegistrations={alertRegistrations}
                                    accountNumber={this.accountno}
                                    typeName={this.name}
                                    isEnabled={this.isEnabled}
                                    ammount={this.state.amount}
                                    removeAlertRegistration={(deliveryAddress , accountNumber,  typeName) =>
                                        this.props.removeAlertRegistration({ deliveryAddress, accountNumber, typeName })
                                    }
                                    addAlertRegistration={(deliveryMethod, accountNumber, alertCriteria, typeName ) =>
                                        this.props.addAlertRegistration({ deliveryMethod, accountNumber, alertCriteria, typeName })
                                    }
                                    
                                />
                            ))
                        }
                        <div className="padding-top">
                            <LinkButton
                                text="Add / Edit Delivery Methods"
                                href="#/alertPreferences/addOrEditMethodComponent"
                            />
                        </div>
                    </div>
                </div>
            );
        }
        else {
            return <LoadingMask ctrlCss="fullpage" />;
        }
    }
}

export default withRouter(AccountAlertTypePage);